export const formatDate = (modifiedDate: Date) => {
    let date = new Date(modifiedDate);
    let formatedDate = date.getFullYear() + '-' + ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '-' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate()))
    return formatedDate;
}

export const formatDateToMMDDYYYY = (modifiedDate: Date) => {
    let date = new Date(modifiedDate);
    let formatedDate = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + "/" + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + "/" + date.getFullYear()
    return formatedDate;
}

